import { useEffect, useState, useCallback } from 'react';
import { getSessionStatus, secondsUntilExpiry, type SessionStatus } from '../lib/session';

const TICK_MS = 30_000;

export interface SessionState {
  status: SessionStatus;
  secondsRemaining: number | null;
}

function snapshot(bufferSeconds: number): SessionState {
  return {
    status: getSessionStatus(Date.now(), bufferSeconds),
    secondsRemaining: secondsUntilExpiry(),
  };
}

/** Reactive JWT session status. Recomputes on a timer and on window focus. */
export function useSessionStatus(bufferSeconds = 120): SessionState {
  const [state, setState] = useState<SessionState>(() => snapshot(bufferSeconds));

  const refresh = useCallback(() => {
    setState(snapshot(bufferSeconds));
  }, [bufferSeconds]);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, TICK_MS);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      clearInterval(id);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, [refresh]);

  return state;
}
